/**
 * hubSyllabusCache — 학습 화면 「강의」 보기가 받아 둔 것(설계 FE-20260914 §6·§8).
 *
 * 학생 한 명의 학습 화면이 떠 있는 동안만 둔다 — 화면이 닫히면(다른 학생·다른 메뉴·로그아웃)
 * StudentLearningPanel 이 비운다. 모듈에만 두면 새로 고치기 전까지 남아, 같은 탭에서 다른 계정이
 * 앞 계정이 받은 배지를 보거나 채점하고 돌아와도 옛 배지·옛 목록이 보인다.
 * 한 화면 안에서 보기를 오갈 때([매스컨셉] ↔ [강의])는 다시 부르지 않는다.
 */

/** `${학생}:${강의}` → 배지 집계 응답(GET /api/v2/syllabi/{id}/progress) */
export const progressCache = new Map();

/** 학생 → 푼 문제 약속(Promise<Map 문제 번호 → 최근 결과>) */
export const solvedCache = new Map();

export function clearHubSyllabusCaches() {
  progressCache.clear();
  solvedCache.clear();
}
